export default __webpack_public_path__ + "static/media/68b91b161e5afaca.f0eca578e4214d0797ea2c7e74ccfa79.svg";